import { setRTL } from '@fluentui/react/lib/Utilities';
import { getOpxHostApi } from 'owa-opx';
import { OpxHostApi } from 'owa-opx';
import { markFunction } from 'owa-performance';
import { hasQueryStringParameter } from 'owa-querystring';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getCultureOverride } from 'owa-shared-bootstrap/lib/getCultureOverride';
import { getSupportedFallbackForLocale } from 'owa-shared-bootstrap/lib/getSupportedFallbackForLocale';
import { loadInitialTheme as loadInitialThemeLegacy } from 'owa-theme-legacy';
import { loadInitialTheme as loadInitialThemeSuite } from 'owa-suite-theme';
import { initializeIsMsHighContrastState } from 'owa-high-contrast';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

import { UserTheme } from '@suiteux/suiteux-shell';

export default markFunction(async function initializeTheme() {
    const userConfig = getUserConfiguration();
    let isRtl = userConfig.SessionSettings.IsUserCultureRightToLeft;
    const cultureOverride = getCultureOverride();
    if (cultureOverride != null) {
        isRtl = getSupportedFallbackForLocale(cultureOverride).dir == 'rtl';
    }
    document.dir = isRtl ? 'rtl' : 'ltr';
    setRTL(isRtl, true); // Ensure ui fabric has up to date RTL

    if (isHostAppFeatureEnabled('loadThemeFromHostApp')) {
        const opxHostApi = getOpxHostApi();
        opxHostApi.registerThemeChangedHandler(isDarkTheme => {
            internalLoadTheme(isDarkTheme, opxHostApi);
        });

        await internalLoadTheme((await opxHostApi.isDarkTheme()) || false, opxHostApi);
    } else {
        if (isFeatureEnabled('fwk-suiteThemes')) {
            loadInitialThemeSuite(
                JSON.parse(userConfig.UserThemeJson) as UserTheme,
                userConfig.UserOptions.IsDarkModeTheme,
                // TODO (SuiteThemes): Where is this value stored?
                true
            );
        } else {
            await loadInitialThemeLegacy(
                userConfig.UserOptions.ThemeStorageId,
                userConfig.UserOptions.IsDarkModeTheme,
                userConfig.SegmentationSettings?.Themes
            );
        }
    }

    initializeIsMsHighContrastState();
}, 'ti');

async function internalLoadTheme(isDarkTheme: boolean, opxHostApi: OpxHostApi) {
    if (isFeatureEnabled('fwk-suiteThemes')) {
        loadInitialThemeSuite(
            JSON.parse(getUserConfiguration().UserThemeJson) as UserTheme,
            isDarkTheme,
            // TODO (SuiteThemes): Where is this value stored?
            true,
            hasQueryStringParameter('useOwaTheme')
                ? undefined
                : await opxHostApi.getOpxPalette(isDarkTheme)
        );
    } else {
        await loadInitialThemeLegacy(
            'base',
            isDarkTheme,
            true,
            hasQueryStringParameter('useOwaTheme')
                ? undefined
                : await opxHostApi.getOpxPalette(isDarkTheme)
        );
    }
}
